import { render } from "./ProductDetailPage.vue?vue&type=template&id=373295d9&scoped=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=373295d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373295d9"]])

export default __exports__